const escapeLinks = new Set()
escapeLinks.add('Download the guide')

function pdfDownloadAriaLabel() {
  let el = document.getElementsByTagName('a')
  el = Array.from(el).filter(item => !escapeLinks.has(item.textContent))

  for (let item of el) {
    if (item?.href?.includes('.pdf') || item?.href?.includes('.PDF')) {
      item?.setAttribute(
        'aria-label',
        item?.target === '_blank'
          ? item?.textContent + ' PDF Opens in new tab'
          : item?.textContent + ' PDF'
      )
    }
  }
}
document.addEventListener('DOMContentLoaded', pdfDownloadAriaLabel)
